// Shipments URL is relative because we have app-dev-XX environments now

export default {
	authServer: 'https://aks-performance.sortedgroup.dev/auth',
	apiHost: 'https://api-perf.sortedgroup.dev/pro-ui',
	gaPropertyId: 'UA-174047108-2',
	remotes: {
		shipments: 'https://performance-portal.sortedgroup.dev/shipments-mf'
	}
};
